import React from 'react';
import { cn } from '@/lib/utils';

interface ProductStageProps {
  className?: string;
  children?: React.ReactNode;
  testId?: string;
}

/** Shared paper-field stage for product entry surfaces. */
const ProductStage: React.FC<ProductStageProps> = ({ className, children, testId = 'product-stage' }) => (
  <div className={cn('relative w-full overflow-hidden', className)} data-testid={testId}>
    <div className="writer-paper-field pointer-events-none absolute inset-0" aria-hidden="true" />
    <div className="writer-stage-glow pointer-events-none absolute inset-0" aria-hidden="true" />
    <div
      aria-hidden="true"
      className="premium-orb premium-orb-animated left-[8%] top-[12%] h-72 w-72 opacity-50 md:h-96 md:w-96"
    />
    <div
      aria-hidden="true"
      className="premium-orb premium-orb-animated bottom-[6%] right-[6%] h-64 w-64 opacity-50 md:h-80 md:w-80"
      style={{ animationDelay: '6s', animationDuration: '26s' }}
    />
    {children}
  </div>
);

export default ProductStage;